// src/store/rolesSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_URL } from '../../utils/constant';

// Async thunk to fetch roles
export const fetchRoles = createAsyncThunk('roles/fetchRoles', async () => {
  const response = await axios.get(`${API_URL}/adminRoles`);
  return response.data;
});

// Async thunk to add a new role
export const addRole = createAsyncThunk('roles/addRole', async (roleData) => {
  const response = await axios.post(`${API_URL}/adminRoles`, roleData);
  return response.data;
});

// Async thunk to update an existing role
export const updateRole = createAsyncThunk('roles/updateRole', async ({ id, roleData }) => {
  const response = await axios.put(`${API_URL}/adminRoles/${id}`, roleData);
  return response.data;
});

export const deleteRole = createAsyncThunk('roles/deleteRole', async (roleId) => {
    const response = await axios.delete(`${API_URL}/adminRoles/${roleId}`); // Replace with your actual API endpoint
    return roleId; // Return the roleId to handle the deletion from the store
  });

const adminRoleSlice = createSlice({
  name: 'adminRoles',
  initialState: {
    roles: [],
    status: 'idle',
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.roles = action.payload;
      })
      .addCase(fetchRoles.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(addRole.fulfilled, (state, action) => {
        state.roles.push(action.payload);
      })
      .addCase(updateRole.fulfilled, (state, action) => {
        const index = state.roles.findIndex((role) => role.id === action.payload.id);
        if (index !== -1) {
          state.roles[index] = action.payload;
        }
      })
      .addCase(deleteRole.fulfilled, (state, action) => {
        state.roles = state.roles.filter(role => role.id !== action.payload);
      });
  },
});

export default adminRoleSlice.reducer;
